import React from 'react';
import { useDispatch } from 'react-redux';
import { NavLink } from 'react-router-dom';


import { sessionOperations } from 'media-base-ui/redux/ducks/session';

import './styles.scss';

const SidebarMenu = () => {
    const dispatch = useDispatch();
    const logout = event => {
        event.preventDefault();
        dispatch(sessionOperations.logout());
    };

    return (
        <nav className="sidebar-nav">
            <ul className="sidebar-menu">
                <li><NavLink to="/auth/profile">Profile</NavLink></li>
                <li><NavLink to="/auth/subscriptions">Subscriptions</NavLink></li>
                <li><NavLink to="/auth/password">Password</NavLink></li>
                <li><a onClick={logout}>Sign Out</a></li>
            </ul>
        </nav>
    );
};


export default SidebarMenu;
